module.exports = __webpack_public_path__ + "img/logo_ibero_horizontal.b4eaad7d.png";